import { createContext } from 'react'

import { SaleTypesContextType } from './useSaleTypes'


const stubFunc = () => {
  console.log('%c👻 Missing Context Provider (SaleTypesData)', 'color: LawnGreen')
  return Promise.resolve(null)
}

export default createContext<SaleTypesContextType>({
  saleTypesState: {},
  loading: true,
  createSaleType: stubFunc,
  modifySaleType: stubFunc,
  replaceSaleTypes: stubFunc,
})
